export default "__VITE_ASSET__CV2uzxi8__"